import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '../../../../../01_atoms/FormElements';
import {
  composeValidators,
  maxDigits,
  minDigits,
  required,
  validEmail,
} from '../../../../../../utils/formFieldValidators';
import ProfileIcon from '../../../../../../public/static/icons/profile-icon.svg';
import { parsePhone, parseSpaceless } from '../../../../../../utils/formFieldParsers';
import { DEFAULT_COUNTRY_CODE } from '../../../../../../utils/constants';
import EmailIcon from '../../../../../../public/static/icons/letter-icon.svg';
import PhoneIcon from '../../../../../../public/static/icons/phone-2024.svg';

const PersonalDetails = ({ withoutPhone }) => {
  return (
    <>
      <TextField
        name="first_name"
        label="First name"
        validate={required('Please enter your first name')}
        isRequired
        placeholder="Jane"
        icon={<ProfileIcon />}
      />

      <TextField
        name="last_name"
        label="Last name"
        validate={required('Please enter your last name')}
        isRequired
        placeholder="Bloggs"
      />

      <TextField
        name="email"
        label="Email address"
        placeholder="jane@email.com"
        parse={parseSpaceless}
        validate={composeValidators(required('Please enter your email address'), validEmail())}
        isRequired
        tooltip={
          DEFAULT_COUNTRY_CODE === 'GB'
            ? 'This lets us send you a receipt for your donation.'
            : 'This is in case we need to contact you about your donation.'
        }
        icon={<EmailIcon />}
      />

      {!withoutPhone && (
        <TextField
          name="phone"
          label="Phone number"
          placeholder={DEFAULT_COUNTRY_CODE === 'GB' ? '+44 1 000 0000' : '+353 1 000 0000'}
          parse={parsePhone}
          validate={
            DEFAULT_COUNTRY_CODE === 'GB'
              ? minDigits(7, 'Please enter a valid phone number with at least 7 digits')
              : composeValidators(
                  required('Please enter a phone number in order to proceed'),
                  minDigits(7, 'Please enter a valid phone number with at least 7 digits'),
                  maxDigits(18, 'Please enter a valid phone number with no longer than 18 digits'),
                )
          }
          isRequired={DEFAULT_COUNTRY_CODE !== 'GB'}
          tooltip={
            DEFAULT_COUNTRY_CODE === 'GB'
              ? undefined
              : 'This is in case we need to contact you about your donation.'
          }
          icon={<PhoneIcon />}
          inputMode="numeric"
          pattern="[0-9+\s\-\(\)\.]+"
          infoOnPatternNotMatched="Please use numbers only"
        />
      )}
    </>
  );
};

PersonalDetails.propTypes = {
  withoutPhone: PropTypes.bool.isRequired,
};

export default PersonalDetails;
